import axios from 'axios'

const client = axios.create({
    baseURL: process.env.VUE_APP_API_DEVICE_URL,
    json: true
})

export default {
    async execute (method, resource, data) {

        let accessToken = localStorage.getItem('jwt');

        return client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            return req.data
        })
    },
    getDevices () {
        return this.execute('get', '/devices/all')
    },
    getDevice (id) {
        return this.execute('get', `/devices/${id}`)
    },
    getDevicesByAccount (accountId) {
        return this.execute('get', `/devices/byacct/${accountId}`)
    },
    createDevice (data) {
        return this.execute('post', '/devices/create', data)
    },
    updateDevice (id, data) {
        return this.execute('put', `/devices/${id}`, data)
    },
    deleteDevice (id) {
        return this.execute('delete', `/devices/${id}`)
    },
    getPlans () {
        return this.execute('get', `/devices/plans/available`)
    },
    subscribeDevice (data) {
        return this.execute('post', '/devices/plans', data)
    },
    updateDevicesSubscription (data) {
        return this.execute('put', '/devices/plans', data)
    },
    getDevicePlans () {
        return this.execute('get', `/devices/plans`)
    },
    toggleValveState (id, state) {
        return this.execute('post', `/devices/${id}/valve/${state}`)
    },
    searchDevices(payload) {
        return this.execute('post', '/devices/self/search', payload)
    },
}